import { QUICK_LABELS } from "./livechatConstants";

// Tone hangat/muted senada tema "Pastel Bouquet" (bukan warna Material generik) — dipakai untuk
// avatar pelanggan (hash by name), lihat livechatTheme.js untuk warna brand & aksen utama.
const AVATAR_COLORS = ["#8c5b73", "#c08a2e", "#6a8f6b", "#a1655a", "#6b7fa3", "#a3708f", "#8a9a5b", "#b3765a"];

export function getAvatarColor(name = "") {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function getInitials(name = "") {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function getLabelColor(labelType) {
    return QUICK_LABELS.find((l) => l.label === labelType)?.color;
}

// Jenis lampiran dari mimetype file lokal — dipakai saat MEMILIH file (sebelum upload), mirror
// deteksi server-side di lotus-be-express/src/modules/livechat/utils/attachment.util.ts.
export function getAttachmentKind(mimeType = "") {
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    return "document";
}
